import validator from "validator";

const REQUIRED_TEXT = 'Dit veld is verplicht';

export const validators = {
  companyName: value => {
    if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
    return false;
  },
  firstName: value => {
    if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
    return false;
  },
  lastName: value => {
    if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
    return false;
  },
  email: value => {
    if (value === undefined || validator.isEmpty(value)) return REQUIRED_TEXT;
    if (!validator.isEmail(value)) return 'Dit is geen geldig e-mail adres';
    return false;
  },
};
